/* unplugin-vue-components disabled */import script from "./plan-pricing.vue?vue&type=script&setup=true&lang=js"
export * from "./plan-pricing.vue?vue&type=script&setup=true&lang=js"

import "./plan-pricing.vue?vue&type=style&index=0&id=da3a2d0a&lang=css"

const __exports__ = script;

export default __exports__